import { combineReducers } from 'redux';
import orderReducer from './orderReducer';
import cartReducer from './cartReducer';
import addressReducer from './addressReducer';
import subscriptionReducer from './subscriptionReducer';
import appConfig from './appConfigReducer';
import {routerReducer} from 'react-router-redux';

const rootReducer = combineReducers({
  order: orderReducer,
  cart: cartReducer,
  address: addressReducer,
  subscription: subscriptionReducer,
  appConfig,
  routing: routerReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js